// extracted by mini-css-extract-plugin
module.exports = {"link":"_1LwLnKY2sa00gZQlH2ViA5","base":"_247pfPfGSoVqEECHyR5NoQ"};